











import {Vue, Component, Prop} from 'vue-property-decorator';
import BottomMain from './BottomMain.vue';
import {Mall} from 'supporter';
import {namespace} from 'vuex-class';
import TopMain from './TopMain.vue';
const mallModule = namespace('mall');
@Component({
  components: {
    BottomMain,
    TopMain
  }
})
export default class Main extends Vue {
  
  @Prop({required: true}) private mainMall!: any;
  @mallModule.State('malls') private stateMalls!: Mall[];
}
